var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col meldingen"},[_c('div',{staticClass:"row no-padding"},[_c('div',{staticClass:"col-md-12 margin-bottom-20",domProps:{"innerHTML":_vm._s(_vm.site.intro)}}),_vm._l((_vm.site.blocks),function(block,key){return _c('div',{key:key,staticClass:"col-md-6 melding"},[_c('component-block',{attrs:{"block":block}})],1)})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }